// extracted by mini-css-extract-plugin
module.exports = {"simulatorProgressCardContainer":"styles_simulatorProgressCardContainer__1vlqP","chevronRightIcon":"styles_chevronRightIcon__221Qy"};